'use client';

import { RecentPagesTracker } from "@/shared/components/layout/recent-pages-tracker";
import { CommandPalette } from '@/shared/components/command-palette';
// Floating bottom-right FAB removed 2026-04-26 — replaced by QuickCreateMenu
// in TopBar so it has a reserved slot and never overlaps form action bars.
import { Sidebar, SidebarProvider } from '@/shared/components/layout/sidebar';
import { TopBar } from '@/shared/components/layout/top-bar';
import { PageBannerProvider } from '@/shared/components/layout/page-banner-context';
import { AuthGuard } from '@/features/auth/components/auth-guard';
import { OnboardingBanner } from '@/features/onboarding/components/onboarding-banner';
import { ImpersonationBanner } from '@/features/admin/components/impersonation-banner';
import { TrialBanner } from '@/features/billing/components/trial-banner';
import { NewCompanyGrantBanner } from '@/features/billing/components/new-company-grant-banner';
import { GlobalTooltip } from '@/shared/components/global-tooltip';
import { KeyboardShortcutsProvider } from '@/shared/components/keyboard-shortcuts/keyboard-shortcuts-provider';
import { RoutePermissionGuard } from '@/shared/components/route-permission-guard';
import { TourTriggerMount } from '@/features/tour/components/tour-trigger-mount';
import { SupportWidget } from '@/features/support/components/support-widget';
import { NotificationAlertsMount } from '@/features/support/components/notification-alerts-mount';
import { NavigationGuardProvider } from '@/shared/components/navigation-guard';

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AuthGuard>
      <SidebarProvider>
        <PageBannerProvider>
        <NavigationGuardProvider>
        <RecentPagesTracker />
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:rounded-md focus:bg-primary-600 focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-white focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        >
          Sari la conținut
        </a>
        <div className="flex h-screen overflow-hidden">
          <Sidebar />
          <div className="flex flex-1 flex-col overflow-hidden">
            <ImpersonationBanner />
            <TrialBanner />
        <NewCompanyGrantBanner />
            <TopBar />
            <main id="main-content" tabIndex={-1} className="flex-1 overflow-y-auto bg-neutral-50 dark:bg-neutral-950 p-2 sm:p-3">
              <OnboardingBanner />
              {children}
            </main>
          </div>
        </div>
        <CommandPalette />
        <KeyboardShortcutsProvider />
        <RoutePermissionGuard />
        <GlobalTooltip />
        <TourTriggerMount />
        <SupportWidget />
        <NotificationAlertsMount />
        </NavigationGuardProvider>
        </PageBannerProvider>
      </SidebarProvider>
    </AuthGuard>
  );
}
